import _ from 'underscore';
import TemplateHtml from '../../../html/engine/home/homeDynamic.html';
import BaseView from '../../baseView';
import { createButtons } from '../../genericButton';
import InputManager from '../../manager/inputManager';
import { camelCase } from '../../util/utilities';

export default class Home extends BaseView {
	get CN() {
		return Home.name;
	}

	get template() {
		return _.template(TemplateHtml);
	}

	className() {
		return 'home';
	}

	inputManagerSectionName() {
		return camelCase(`${_.result(this, 'className')} Page`);
	}

	initialize(options) {
		this.logger.log('[initialize]', { options });

		this.inputConfig = {};

		super.initialize(options);
		this.render();

		const classNames = _.result(this, 'className')
			.split(' ')
			.map((className) => `.${className}`)
			.join('');
		const gameButtonSelector = `${classNames} .btn:not(.disabled)`;

		InputManager.add(this.inputManagerSectionName(), {
			selector: gameButtonSelector,
			...this.inputConfig,
		});
	}

	render() {
		this.logger.log('[render]');

		super.render();
		const { pages = [] } = this.options;
		this.$('#gameContainer').empty().append(createButtons(pages));

		this.wait().then(() => {
			InputManager.focus(this.inputManagerSectionName());
			this.logger.debug(`Focusing "${this.inputManagerSectionName()}"`);
		});
	}
}
